export default __webpack_public_path__ + "static/media/nu.99c3f3d5.jpg";